const axios = require("axios").default;
const utilities = require("../../utilities");
const models = require("../models");
const logger = require("../../logger");

axios.interceptors.request.use((request) => {
  //Don't log oauth token request-- contains API key
  if (request.baseURL === "https://identity.fortellis.io") {
    logger.log("info", "Getting OAuth2 token from fortellis; sdk", { tags: "sdk,fortellis"});
    return request;
  } else {
    logger.log("info", `Axios Request to CDK`, { tags: "sdk,fortellis", additionalInfo: { request: request } });
    return request;
  }
});
// axios.interceptors.response.use((x) => {
//   if (utilities.getPropValue(x, "data.access_token")) {
//     return x;
//   } else {
//     logger.log("info", "CDK Axios Response", { tags: "sdk,fortellis", additionalInfo: { responseData: x.data, responseHeaders: x.headers } });
//     return x;
//   }
// });
log = false;
class cdk {
  constructor(token) {
    this.oauthAccessToken = token;
  }

  async init() {
    this.oauthAccessToken = await getOauthToken(process.env.CDK_USER, process.env.CDK_PASSWORD);
  }

  /** Fetch Repair Order object from CDK
   * @param {Object} parsedConfig - Contains subscription_id (Authorization to access customer's CDK data)
   * @param {String} repairOrderId - CDK id for Repair Order
   * @return {Object} Standardized JSON of Repair Order data
   */
  async getRepairOrder(parsedConfig, repairOrderId) {
    try {
      let subscriptionId = utilities.getPropValue(parsedConfig, "dms.props.subscription_id");
      if (typeof subscriptionId !== "string") {
        throw new Error("Subscription_id must be a string");
      }
      //query https://api.fortellis.io/cdkdrive/service/v1/repair-orders/{id}
      let queryUrl = `https://api.fortellis.io/cdkdrive/service/v1/repair-orders/${repairOrderId}`;
      return this.axiosGet(queryUrl, subscriptionId, repairOrderId).then((res, err) => {
        if (err) throw err;
        //validate and parse response
        if (res.data) {
          logger.log("info", "Fortellis Repair Order Data; sdk", { tags: "sdk,fortellis", additionalInfo: { headers: res.headers, data: res.data } });

          let data = res.data;
          //return standardized JSON object of RO data
          let repairOrderObject = this.setRepairOrderObject(data);
          //Must contain customer and vehicle ids, but put a few other things in as well
          return repairOrderObject;
        } else {
          logger.log("info", `No Fortellis Data Found for Repair Order ${repairOrderObject}; sdk`, {
            tags: "sdk,fortellis",
            additionalInfo: { response: res },
          });
          throw new Error("No Data Returned");
        }
      });
    } catch (err) {
      logger.log("error", "Error Getting Fortellis Repair Order Data; sdk", { tags: "sdk,fortellis", additionalInfo: { err: err } });
      console.error(err);
      throw err;
    }
  }

  /** Transform Repair Order Object returned from cdk into the data we want to insert into db
   * @param {Object} data - The response object returned from cdk
   * @return {Object} A standardized JSON object containing fields to be inserted into hasura
   */
  setRepairOrderObject(data) {
    let repairOrder = { ...models.repairOrder };
    repairOrder.repair_order_number = data.repairOrderId;
    repairOrder.vehicleId = data.vehicleHref.split("/").pop();
    repairOrder.customerId = data.customerHref.split("/").pop();
    repairOrder.PO_number = data.poNumber;
    repairOrder.transport_type = utilities.toProperCase(data.transportType);
    repairOrder.service_line_items_count = data.serviceLineItems.length;
    //loop over Service Line Items
    data.serviceLineItems.forEach((item) => {
      repairOrder.labor_operations_count += item.laborOperations.length;
      //Loop over labor operations array within each line item
      item.laborOperations.forEach((operation) => {
        repairOrder.total_labor_cost += operation.saleAmount;
        repairOrder.parts_count += operation.includedParts.length;
        //Loop over includedParts array
        operation.includedParts.forEach((part) => {
          repairOrder.total_part_cost += part.saleAmount;
        });
      });
    });
    return repairOrder;
  }

  /** Fetch Vehicle object from CDK
   * @param {Object} parsedConfig - Contains subscription_id (Authorization to access customer's CDK data)
   * @param {String} vehicleId - CDK id for Vehicle
   * @return {Object} Standardized single level JSON of Vehicle data
   */
  async getVehicle(parsedConfig, vehicleId) {
    try {
      let subscriptionId = utilities.getPropValue(parsedConfig, "dms.props.subscription_id");
      if (typeof subscriptionId !== "string") {
        throw new Error("Subscription_id must be a string");
      }
      //query https://api.fortellis.io/cdkdrive/service/v1/vehicles/{id}
      let queryUrl = `https://api.fortellis.io/cdkdrive/service/v1/vehicles/${vehicleId}`;
      return this.axiosGet(queryUrl, subscriptionId, vehicleId).then((res, err) => {
        if (err) throw err;
        //validate and parse response
        if (res.data) {
          logger.log("info", "Fortellis Vehicle Data; sdk", { tags: "sdk,fortellis", additionalInfo: { headers: res.headers, data: res.data } });

          //return simplified JSON object of vehicle data
          //{make, model, year, color, VIN}
          let vehicleFlat = utilities.flattenObject(res.data);
          let vehicleObject = {
            vehicle_vin: vehicleFlat.vin,
            vehicle_make: vehicleFlat.make,
            vehicle_model: vehicleFlat.model,
            vehicle_year: `${vehicleFlat.modelYear}`,
            vehicle_color: utilities.toProperCase(vehicleFlat.exteriorColor),
            vehicle_stock: "",
            reference_num: "",
            manual_flag: false,
          };
          return vehicleObject;
        } else {
          logger.log("info", `No Fortellis Data Found for Vehicle ${vehicleId}; sdk`, { tags: "sdk,fortellis", additionalInfo: { response: res } });
          throw new Error("No Data Returned");
        }
      });
    } catch (err) {
      logger.log("error", "Error Getting Fortellis Vehicle Data; sdk", { tags: "sdk,fortellis", additionalInfo: { err: err } });
      console.error(err);
      throw err;
    }
  }

  /** Fetch Consumer object from CDK
   * @param {Object} parsedConfig - - Contains subscription_id (Authorization to access customer's CDK data)
   * @param {String} customerId - CDK id for Consumer
   * @return {Object} Standardized single level JSON of Consumer data
   */
  async getCustomer(parsedConfig, customerId) {
    try {
      let subscriptionId = utilities.getPropValue(parsedConfig, "dms.props.subscription_id");
      if (typeof subscriptionId !== "string") {
        throw new Error("Subscription_id must be a string");
      }
      //query https://api.fortellis.io/cdkdrive/service/v1/customers/{id}
      let queryUrl = `https://api.fortellis.io/cdkdrive/crm/v1/customers/${customerId}`;
      return this.axiosGet(queryUrl, subscriptionId, customerId).then((res, err) => {
        if (err) {
          throw err;
        }
        //validate and parse response
        if (res.data) {
          logger.log("info", "Fortellis Customer Data; sdk", { tags: "sdk,fortellis", additionalInfo: { headers: res.headers, data: res.data } });

          //Note: Three phone numbers are included bc I'm not sure which one will actually be filled out in real data
          let data = res.data;
          let contactMethods = data.contactMethods ? data.contactMethods : {};
          let fullName = data.name ? `${data.name.first} ${data.name.last}` : null;
          let customerObject = {
            customerId: customerId,
            fullName: fullName,
            homePhone: contactMethods.homePhone,
            mobilePhone: contactMethods.mobilePhone,
            primaryPhone: contactMethods.primaryPhone,
          };
          return customerObject;
        } else {
          logger.log("info", `No Fortellis Data Found for Customer ${customerId}; sdk`, { tags: "sdk,fortellis", additionalInfo: { response: res } });
          throw new Error("No Data Returned");
        }
      });
    } catch (err) {
      logger.log("error", "Error Getting Fortellis Customer Data; sdk", { tags: "sdk,fortellis", additionalInfo: { err: err } });
      console.error(err);
      throw err;
    }
  }

  /** Wrapper for Axios calls to the CDK API
   * @param {Object} url - API url + id to query
   * @param {String} subscription_id - subscriptions_id for customer's data
   * @param {String} request_id - requests_id for customer's data
   * @return {Object} Standardized single level JSON of Repair Order data
   */
  async axiosGet(url, subscription_id, request_id) {
    // logger.log("info", `running axios get for url: ${url} with subscription_id: ${subscription_id} and request-id: ${request_id}`, { tags: "sdk,fortellis" });
    if (!this.oauthAccessToken) {
      this.oauthAccessToken = await getOauthToken(process.env.CDK_USER, process.env.CDK_PASSWORD);
    } else {
      log && console.log("token exists");
    }
    return await axios.get(url, {
      headers: {
        get: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        "Subscription-Id": subscription_id,
        Authorization: this.oauthAccessToken,
        // Authorization: token,
      },
    });
  }
}

/** Returns an OAuth Bearer Token which can be used to access Fortellis APIs
 * @param {String} apiKey - app's API key
 * @param {String} apiSecret - app's API secret
 */
getOauthToken = async function (apiKey, apiSecret) {
  if (!apiKey) {
    throw new Error("Error retrieving oauth token: no key provided");
  }
  if (!apiSecret) {
    throw new Error("Error retrieving oauth token: no secret provided");
  }
  if (typeof apiKey !== "string") {
    throw new Error("Error retrieving oauth token: key must be type string");
  }
  if (typeof apiKey !== "string") {
    throw new Error("Error retrieving oauth token: secret must be type string");
  }
  try {
    let oauthToken = await axios.request({
      url: "/oauth2/aus1p1ixy7YL8cMq02p7/v1/token",
      method: "post",
      baseURL: "https://identity.fortellis.io",
      auth: {
        username: apiKey,
        password: apiSecret,
      },
      data: {
        grant_type: "client_credentials",
        scope: "anonymous",
      },
    });
    if (oauthToken.data && oauthToken.data.access_token) {
      log && console.log("GET TOKEN");
      this.oauthAccessToken = "Bearer " + oauthToken.data.access_token;
      return "Bearer " + oauthToken.data.access_token;
    } else {
      //How best to handle this failure? (if this fails, then all cdk axios calls are unusable)
      log && console.log("error getting token");
      throw "Could not retrieve oauth2 token from Fortellis- no APIs can be accessed";
    }
  } catch (err) {
    console.error(err.message);
  }
};
module.exports = cdk;
